<template>
  <div id="mobile_menu" :class="{ mobile_menu: true, 'is-active': isActive }">
    <div :class="{ 'content-active': isActive }" class="content">
      <div
        style="
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 30px;
        "
      >
        <a class="" href="/">
          <div class="logo"></div>
        </a>
        <button class="mob-close is-huge" aria-label="close" @click="closeMenu">
          <CrossIcon />
        </button>
      </div>
      <div style="display: flex; flex-direction: column; width: max-content">
        <ul>
          <li @click="closeMenu">
            <MobileNavTabLock permission="LIVE_VIEW" to="/live">
              {{ capitalize($t("live")) }}
              <template #counter>
                <div class="counter">{{ matchCount }}</div>
              </template>
            </MobileNavTabLock>
          </li>
          <li @click="closeMenu">
            <MobileNavTabLock permission="PREMATCH_VIEW" to="/prematch">
              {{ capitalize($t("prematch")) }}
              <template #counter>
                <div class="counter">{{ prematchCount }}</div>
              </template>
            </MobileNavTabLock>
          </li>
          <li @click="closeMenu">
            <MobileNavTabLock permission="TICKER_VIEW" to="/ticker">
              {{ capitalize($t("ticker")) }}
              <template #counter>
                <div class="counter">{{ matchCount }}</div>
              </template>
            </MobileNavTabLock>
          </li>
          <li @click="closeMenu">
            <router-link
              class="tab-link"
              to="/subscriptions"
              :exact="`/subscriptions` === '/'"
            >
              {{ capitalize($t("subscription")) }}
            </router-link>
          </li>
        </ul>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 30px;
            margin-top: 180px;
          "
          class="nav"
        >
          <div style="display: flex; align-items: center; gap: 15px">
            <ThemeSwitcherHeader />
            <LangSwitch is-short />
          </div>
          <UserMenu :user="user" @close-menu="closeMenu" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LangSwitch from "./LangSwitch.vue";
import ThemeSwitcherHeader from "./ThemeSwitcherHeader.vue";
import UserMenu from "./common/UserMenu.vue";
import CrossIcon from "./common/icons/Cross.vue";
import MobileNavTabLock from "./MobileNavTabLock.vue";

export default {
  name: "MobileMenu",
  components: {
    LangSwitch,
    ThemeSwitcherHeader,
    UserMenu,
    CrossIcon,
    MobileNavTabLock,
  },
  props: {
    isActive: Boolean,
  },
  data: () => ({
    isMenuActive: false,
  }),
  computed: {
    prematchCount() {
      return (
        this.$store.state.prematch.matches.length ||
        this.$store.state.prematch.count
      );
    },
    matchCount() {
      return this.$store.state.match.list.length;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    closeMenu() {
      this.$emit("close-menu");
    },

    getMediaPreference() {
      const hasDarkPreference = window.matchMedia(
        "(prefers-color-scheme: dark)",
      ).matches;
      if (hasDarkPreference) {
        return "dark-theme";
      } else {
        return "light-theme";
      }
    },

    logout() {
      return this.$store.dispatch("logout").then(() => {
        this.$router.go();
      });
    },
  },
};
</script>

<style scoped>
.mobile_menu {
  display: none;
  pointer-events: none;
  position: fixed;
  transition: all 0.7s ease-in-out;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #333333bc;
  opacity: 0;
  z-index: 99999;
  flex-direction: column;
  align-items: flex-end;
}

.is-active {
  display: flex;
  opacity: 1;
  pointer-events: all;
}

#mobile_menu .content {
  position: relative;
  top: 0;
  right: -100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--body-color);
  max-width: 382px;
  padding: 50px;
  transition: all 0.7s ease-in-out;
}

#mobile_menu .content .icon-cross {
  cursor: pointer;
}

#mobile_menu .content-active {
  right: 0;
}

#mobile_menu .content .logo {
  display: block;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 32px;
  line-height: 39.68px;

  &:before {
    content: "SCORE";
    color: var(--font-color);
  }

  &:after {
    content: "68";
    color: #06d6a0;
  }

  .beta {
    font-size: 0.6rem;
    position: absolute;
    top: 0.25rem;
    right: 0;
  }
}

#mobile_menu ul {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
}

#mobile_menu ul li {
  list-style: none;
}

#mobile_menu ul li a {
  color: var(--back-color);
  font-size: 36px;
  font-weight: 500;
  line-height: 46.8px;
}

#mobile_menu ul li a.router-link-active {
  color: var(--brand-color);
}

#mobile_menu .tab-link {
  display: flex;
  gap: 6px;
  align-items: center;

  &.router-link-active {
    color: var(--brand-color);
  }
}

#mobile_menu .counter {
  width: max-content;
  height: max-content;
  font-weight: 700;
  font-size: 20px;
  line-height: 25.04px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--danger-color);
  color: #ffffff;
  padding: 4px 8px 4px 8px;
  border-radius: 100px;
}

.login {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 12px 24px;
  gap: 12px;
  border-radius: 150px;
  outline: none;
  border: none;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 1px;
  color: var(--font-color);
  font-weight: 400;
  background-color: var(--league-body-color);
  cursor: pointer;
}

.is-active {
  opacity: 1 !important;
  pointer-events: all !important;
}

.mob-close {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 100;
  height: 40px;
  width: 40px;
  padding: 5px;
  stroke: var(--font-color);
}

@media screen and (max-width: 420px) {
  .content {
    max-width: 268px !important;
    padding: 30px !important;
  }

  #mobile_menu .content .logo {
    font-size: 24px;
    line-height: 29.76px;
  }

  #mobile_menu .icon-cross {
    width: 30px;
    height: 30px;
  }

  #mobile_menu ul li a {
    font-size: 26px;
    line-height: 33.8px;
  }

  #mobile_menu .counter {
    font-size: 12px;
    padding: 4px 8px 4px 8px;
  }

  #mobile_menu .nav {
    margin-top: 48px !important;
  }
}
</style>
